import { Link } from 'react-router-dom';
import { homeFaqs } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="FAQ"
              title="关于投稿与联系，你可能想问"
              description="这里整理了用户最常提出的问题。如果仍有疑问，欢迎通过一般咨询邮箱联系我们。"
            />

            <div className="mt-8 bg-secondary-950 text-background-100 rounded-lg p-6">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-question-answer-line text-lg"></i>
                </span>
                <p className="font-heading text-base font-bold text-background-50">还有其他疑问？</p>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-background-200">
                直接写一封邮件，说明你的问题即可。我们不会要求你提供任何与咨询无关的个人信息。
              </p>
              <Link
                to="/contact"
                className="mt-5 inline-flex items-center gap-2 bg-background-50 hover:bg-accent-500 hover:text-foreground-950 text-foreground-950 text-sm font-medium px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                前往联系方式
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-8">
            <FaqAccordion items={homeFaqs} idPrefix="home-faq" />
          </div>
        </div>
      </div>
    </section>
  );
}